import Api from '@/services/Api'

export default {
  log (msg, bold) {
    if (process.env.NODE_ENV === 'development') {
      if (bold) {
        console.log('%c' + msg, 'font-weight:bold')
      } else {
        console.log(msg)
      }
    }
  },
  getPath () {
    if (process.env.NODE_ENV === 'development') {
      return window.location.pathname ? window.location.pathname : '/erhverv/brancher/kvittering-kontor-og-bureau'
    }
    return window.location.pathname
  },
  getContact (cvr, guidePage) {
    const url = `/tryg/api/commercial_guide/${cvr}/contact?$guidePage=${guidePage}&path=` + this.getPath()
    this.log('Services.getContact()', true)
    this.log(new Date().toUTCString())
    this.log(url)
    const response = Api().get(url)
    this.log(response)
    return response
  },
  postForm (cvr, guidePage, data) {
    const url = `/tryg/api/commercial_guide/${cvr}?%24guidePage=${guidePage}&path=` + this.getPath()
    this.log('Services.postForm()', true)
    this.log(new Date().toUTCString())
    this.log(url)
    this.log(data)
    const response = Api().post(url, data)
    this.log(response)
    return response
  },
  getInsurances (cvr, guidePage, data) {
    const url = `/tryg/api/commercial_guide/${cvr}/insurances?%24guidePage=${guidePage}&path=` + this.getPath()
    this.log('Services.getInsurances()', true)
    this.log(new Date().toUTCString())
    this.log(url)
    this.log(data)
    const response = Api().post(url, data)
    this.log(response)
    return response
  },
  getQuestionsDefault (guidePage) {
    const url = `/tryg/api/commercial_guide/questions?$guidePage=${guidePage}&path=` + this.getPath()
    this.log('Services.getQuestionsDefault()', true)
    this.log(new Date().toUTCString())
    this.log(url)
    const response = Api().get(url)
    this.log(response)
    return response
  },
  getQuestionsByCvr (cvr, guidePage) {
    const url = `/tryg/api/commercial_guide/${cvr}?$guidePage=${guidePage}&path=` + this.getPath()
    this.log('Services.getQuestionsByCvr()', true)
    this.log(new Date().toUTCString())
    this.log(url)
    const response = Api().get(url)
    this.log(response)
    return response
  }
}



// WEBPACK FOOTER //
// ./src/services/Services.js